export default __webpack_public_path__ + "static/fall26-539c387fea3f90d546585c0ef3dd97f3.webp";